import React from 'react'

import News from '../components/News'

const NewsPage = () => {
  return (
    <>
      <h1>News</h1>
      <News />
    </>
  )
}

export default NewsPage
